
import { useEffect, useState } from 'react';
import Navbar from '../Components/NavBarV2';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import videoFondo from '../images/videoFondo.mp4';
import { db, storage } from '../Firebase/Firebase';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification, signOut, signInWithEmailAndPassword } from "firebase/auth";
import appFirebase from "../Firebase/Firebase";
import { getFirestore, getDoc, getDocs, collection, addDoc, setDoc, doc, query, where, updateDoc, deleteDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject, listAll } from "firebase/storage";
import Modal from 'react-modal';
import './users.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Users = () => {

    const auth = getAuth(appFirebase);
    const [usuarios, setUsuarios] = useState([]);
    // Función para obtener usuarios según el rol del usuario autenticado
    const users = async () => {
        try {
            // Obtener el usuario autenticado
            const user = auth.currentUser;

            if (!user) {
                console.error("No se encontró un usuario autenticado.");
                return;
            }

            const userId = user.uid; // ID del usuario autenticado
            const userDocRef = doc(db, "usuarios", userId);
            const userDocSnap = await getDoc(userDocRef);

            if (!userDocSnap.exists()) {
                console.error("No se encontró el usuario en Firestore.");
                return;
            }

            const currentUser = userDocSnap.data();
            const currentUserRole = currentUser.role;

            console.log(`Rol del usuario actual: ${currentUserRole}`);

            let querySnapshot;
            if (currentUserRole === "admin") {
                // Si el rol es "admin", obtener todos los usuarios
                querySnapshot = await getDocs(collection(db, "usuarios"));
            } else if (currentUserRole === "prov") {
                // Si el rol es "prov", obtener solo los usuarios creados por este usuario
                const q = query(collection(db, "usuarios"), where("createdBy", "==", userId));
                querySnapshot = await getDocs(q);
            } else {
                console.warn("Rol desconocido, no se aplicará ningún filtro.");
                return;
            }

            // Mapear los usuarios obtenidos
            const usuariosData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setUsuarios(usuariosData);

            console.log("Usuarios filtrados:", usuariosData);
        } catch (error) {
            console.error("Error al obtener los usuarios:", error);
        }
    };
    const [userRole, setUserRole] = useState("");
    const [userId, setUserId] = useState("");

    // Función para obtener el id y rol del usuario autenticado
    const getUserRoleAndId = async () => {
        const auth = getAuth();
        const db = getFirestore();

        const user = auth.currentUser; // Obtener el usuario autenticado
        if (!user) {
            console.error("No hay usuario autenticado.");
            return null;
        }

        try {
            // Obtener datos adicionales del usuario desde Firestore
            const userDocRef = doc(db, "usuarios", user.uid); // Buscar el documento del usuario en Firestore
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                const userData = userDocSnap.data();
                return { id: user.uid, role: userData.role }; // Devuelve el id y el rol
            } else {
                console.error("No se encontró el usuario en Firestore.");
                return null;
            }
        } catch (error) {
            console.error("Error al obtener los datos del usuario:", error);
            return null;
        }
    };

    // Llamar a la función y establecer los valores de userRole y userId al cargar el componente
    useEffect(() => {
        const fetchUserData = async () => {
            const userData = await getUserRoleAndId();
            if (userData) {
                setUserRole(userData.role);
                setUserId(userData.id);
            }
        };

        fetchUserData();
    }, []);


    // Obtener los tipos de espacio cuando el componente se monta
    useEffect(() => {
        users();
    }, []);

    const [isAdmin, setIsAdmin] = useState(false); // Para controlar si es administrador
    const [formData, setFormData] = useState({
        name: '',
        lastName: '',
        email: '',
        cedula: '',
        password: '',
        confirmPassword: '',
        role: '',
        ruc: '',
        telefono: ''
    });

    useEffect(() => {
        const fetchUserRole = async () => {
            const user = auth.currentUser; // Obtener el usuario autenticado

            if (!user) {
                console.error("No se encontró un usuario autenticado.");
                return;
            }

            try {
                // Obtener los datos del usuario desde Firestore usando su ID (user.uid)
                const userRef = doc(db, "usuarios", user.uid); // Ajusta la colección si es diferente
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const userData = userSnap.data();
                    setIsAdmin(userData.role === "admin"); // Verifica si el rol es 'admin'
                } else {
                    console.error("No se encontró el documento del usuario");
                }
            } catch (error) {
                console.error("Error al obtener el rol del usuario:", error);
            }
        };

        fetchUserRole();
    }, []); // Solo se ejecuta una vez al montar el componente

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (name === "ruc") {
            if (value.length === 13) {
                const error = validarRUC(value);

                // Establece el mensaje de error si es inválido, o limpia el mensaje si es válido
                if (error) {
                    setRucError(error);
                } else {
                    setRucError("");
                }
            } else {
                setRucError(""); // Limpia el mensaje mientras se escribe
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            toast.error("Las contraseñas no coinciden.");
            return;
        }

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
            const user = userCredential.user;

            await sendEmailVerification(user);

            const createdByUserId = localStorage.getItem("currentUserId");
            if (!createdByUserId) {
                toast.error("No se pudo obtener el ID del usuario creador.");
                return;
            }

            const userDoc = {
                userId: user.uid,
                createdBy: createdByUserId,
                name: formData.name,
                lastName: formData.lastName,
                email: formData.email,
                cedula: formData.cedula,
                telefono: formData.telefono,
                role: "user",
                coins: "",
                coinsComprados: "",
                nuevo: false,
                lastConnection: new Date().toISOString(),
                tipoUser: "persona",
                ruc: formData.ruc,
            };

            await setDoc(doc(db, "usuarios", user.uid), userDoc);

            setFormData({
                name: "",
                lastName: "",
                email: "",
                cedula: "",
                telefono: "",
                password: "",
                confirmPassword: "",
                role: "",
                ruc: "",
            });

            const email = localStorage.getItem("currentUserEmail");
            const password = localStorage.getItem("currentUserPassword");

            if (email && password) {
                await signInWithEmailAndPassword(auth, email, password);
                toast.success("Sesión restaurada correctamente.");
            }

            toast.success("Usuario creado con éxito.");
        } catch (error) {
            console.error("Error al registrar usuario:", error);
            toast.error("Error al registrar usuario: " + error.message);
        }
    };



    const [selectedUsuario, setSelectedUsuario] = useState(null);
    const [modalIsOpenUpdate, setModalIsOpenUpdate] = useState(false);

    const openModalUpdate = (usuario) => {
        setEditedUsuario({ ...usuario, userId: usuario.userId });
        setModalIsOpenUpdate(true);
    };


    const closeModalUpdate = () => {
        setModalIsOpenUpdate(false);
        setEditedUsuario({});
    };
    const [editedUsuario, setEditedUsuario] = useState({
        name: "",
        lastName: "",
        cedula: "",
        telefono: "",
        coins: "",
        coinsComprados: "",
        nuevo: false, // o 'Nuevo'/'Antiguo'
        role: "",
        ruc: ""
    });

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedUsuario((prevState) => ({
            ...prevState,
            [name]: value
        }));
        // Validar cédula solo si el campo es "cedula"
        if (name === "cedula") {
            if (value.length === 10) {
                const error = validarCedulaEcuador(value);

                // Establece el mensaje de error si es inválida, o limpia el mensaje si es válida
                if (error) {
                    setCedulaErrorEdit(error);
                } else {
                    setCedulaErrorEdit("");
                }
            } else {
                setCedulaErrorEdit(""); // Limpia el mensaje mientras se escribe
            }
        }
        if (name === "ruc") {
            if (value.length === 13) {
                const error = validarRucEcuador(value);

                // Establece el mensaje de error si es inválida, o limpia el mensaje si es válida
                if (error) {
                    setCedulaErrorEdit(error);
                } else {
                    setCedulaErrorEdit("");
                }
            } else {
                setCedulaErrorEdit(""); // Limpia el mensaje mientras se escribe
            }
        }
    };


    // Función para manejar la edición de un usuario
    const handleEditSubmit = async (e) => {
        e.preventDefault();

        if (!editedUsuario || !editedUsuario.userId) {
            console.error("Error: El usuario seleccionado es null o undefined.");
            return;
        }

        // Obtener el ID y el rol del usuario autenticado
        const userData = await getUserRoleAndId();
        if (!userData) {
            console.error("Error: No se pudo obtener los datos del usuario autenticado.");
            return;
        }

        const { id: createdByUserId } = userData; // El ID del usuario autenticado

        // Asegurarnos de que ningún campo sea undefined
        const updatedData = {
            createdBy: createdByUserId || null,
            userId: editedUsuario.userId,
            name: editedUsuario.name || "", // Valor predeterminado si está undefined
            lastName: editedUsuario.lastName || "",
            cedula: editedUsuario.cedula || "",
            coins: editedUsuario.coins || 0,
            coinsComprados: editedUsuario.coinsComprados || 0,
            nuevo: editedUsuario.nuevo || false,
            role: editedUsuario.role || "",
            ruc: editedUsuario.ruc || "",
            telefono: editedUsuario.telefono || "",
            tipoUser: "persona",
        };

        try {
            await setDoc(doc(db, "usuarios", editedUsuario.userId), updatedData);
            closeModalUpdate();
            users(); // Refresca la lista de usuarios
            window.location.reload();
        } catch (error) {
            console.error("Error al actualizar el usuario:", error);
        }
    };


    const [modalIsOpenDelete, setModalIsOpenDelete] = useState(false);

    // Función para abrir el modal con los datos del usuario
    const openDeleteModal = (usuario) => {
        setSelectedUsuario(usuario); // Asigna el usuario seleccionado
        setModalIsOpenDelete(true);    // Abre el modal
    };

    // Función para cerrar el modal
    const closeModalDelete = () => {
        setModalIsOpenDelete(false);
        setSelectedUsuario(null); // Limpia la selección del usuario
    };

    // Función para eliminar al usuario
    const handleDelete = async () => {
        if (!selectedUsuario || !selectedUsuario.userId) {
            toast.error("Error: Usuario no encontrado.");
            return;
        }

        const userId = selectedUsuario.userId;

        try {
            // Eliminar el documento de Firestore
            await deleteDoc(doc(db, "usuarios", userId));

            closeModalDelete();
            window.location.reload();

            users();

        } catch (error) {
            console.error("Error al eliminar el usuario: ", error);
            toast.error("Hubo un error al eliminar el usuario.");
        }
    };


    const validarCedulaEcuador = (identificacion) => {
        // Verificar longitud
        if (identificacion.length !== 10 && identificacion.length !== 13) {
            return "La identificación debe tener 10 o 13 dígitos.";
        }

        // Validar cédula (primeros 10 dígitos)
        const cedula = identificacion.substring(0, 10);

        // Validar región
        const digitoRegion = parseInt(cedula.substring(0, 2), 10);
        if (digitoRegion < 1 || digitoRegion > 24) {
            return "La cédula no pertenece a ninguna región válida.";
        }

        // Validar último dígito de la cédula
        const ultimoDigito = parseInt(cedula.substring(9, 10), 10);

        // Sumar pares
        const pares =
            parseInt(cedula.substring(1, 2), 10) +
            parseInt(cedula.substring(3, 4), 10) +
            parseInt(cedula.substring(5, 6), 10) +
            parseInt(cedula.substring(7, 8), 10);

        // Procesar impares
        const calcularImpar = (digito) => {
            const resultado = digito * 2;
            return resultado > 9 ? resultado - 9 : resultado;
        };

        const impares =
            calcularImpar(parseInt(cedula.substring(0, 1), 10)) +
            calcularImpar(parseInt(cedula.substring(2, 3), 10)) +
            calcularImpar(parseInt(cedula.substring(4, 5), 10)) +
            calcularImpar(parseInt(cedula.substring(6, 7), 10)) +
            calcularImpar(parseInt(cedula.substring(8, 9), 10));

        // Sumar total
        const sumaTotal = pares + impares;

        // Extraer primer dígito de la suma
        const primerDigitoSuma = parseInt(String(sumaTotal).substring(0, 1), 10);

        // Decena inmediata
        const decenaInmediata = (primerDigitoSuma + 1) * 10;

        // Calcular dígito validador
        let digitoValidador = decenaInmediata - sumaTotal;
        if (digitoValidador === 10) digitoValidador = 0;

        // Verificar dígito validador
        if (digitoValidador !== ultimoDigito) {
            return "La cédula no es válida.";
        }

        // Si tiene 13 dígitos, validar RUC
        if (identificacion.length === 13) {
            const ruc = identificacion.substring(10, 13);
            if (ruc !== "001") {
                return "El RUC debe terminar en 001.";
            }
        }

        return null; // La identificación es válida
    };
    const validarRucEcuador = (ruc) => {
        // Verificar longitud
        if (ruc.length !== 13) {
            return "El RUC debe tener exactamente 13 dígitos.";
        }

        // Validar región (primeros 2 dígitos)
        const digitoRegion = parseInt(ruc.substring(0, 2), 10);
        if (digitoRegion < 1 || digitoRegion > 24) {
            return "El RUC no pertenece a una región válida.";
        }

        // Validar si los primeros 10 dígitos corresponden a una cédula válida
        const cedula = ruc.substring(0, 10);
        const cedulaError = validarCedulaEcuador(cedula); // Usar la función de cédula existente
        if (cedulaError) {
            return "Los primeros 10 dígitos del RUC no corresponden a una cédula válida.";
        }

        // Validar que los últimos 3 dígitos sean '001'
        const terminacion = ruc.substring(10, 13);
        if (terminacion !== "001") {
            return "El RUC debe terminar con '001'.";
        }

        return null; // RUC válido
    };

    const [cedulaError, setCedulaError] = useState("");
    const [rucError, setRucError] = useState("");

    const handleCedulaChange = (e) => {
        const cedula = e.target.value;

        // Actualiza el estado del formulario
        setFormData({ ...formData, cedula });

        // Valida la cédula solo si tiene 10 dígitos
        if (cedula.length === 10) {
            const error = validarCedulaEcuador(cedula);

            // Si hay error, mostrar mensaje de error en rojo
            if (error) {
                setCedulaError(error);
            } else {
                // Si no hay error, mensaje vacío (cédula válida)
                setCedulaError("");
            }
        } else {
            setCedulaError(""); // Limpia el error mientras se escribe
        }
    };
    const handleRucChange = (e) => {
        const ruc = e.target.value;

        // Actualiza el estado del formulario
        setFormData({ ...formData, ruc });

        // Valida el RUC solo si tiene 13 dígitos
        if (ruc.length === 13) {
            const error = validarRucEcuador(ruc);

            // Si hay error, mostrar mensaje de error en rojo
            if (error) {
                setRucError(error);
            } else {
                // Si no hay error, mensaje vacío (RUC válido)
                setRucError("");
            }
        } else {
            setRucError(""); // Limpia el error mientras se escribe
        }
    };

    const [cedulaErrorEdit, setCedulaErrorEdit] = useState("");

    const validarRUC = (ruc) => {
        // Verificar longitud
        if (ruc.length !== 13) return "El RUC debe tener exactamente 13 dígitos.";

        // Validar que los primeros 10 dígitos formen una cédula válida
        const cedula = ruc.substring(0, 10);
        const cedulaError = validarCedulaEcuador(cedula);
        if (cedulaError) return "Los primeros 10 dígitos del RUC no forman una cédula válida.";

        // Validar que los últimos tres dígitos sean '001'
        const extension = ruc.substring(10, 13);
        if (extension !== "001") return "Los últimos tres dígitos del RUC deben ser '001'.";

        return null; // RUC válido
    };



    return (
        <div>
            <Navbar />
            <ToastContainer />
<br/>
<br/>
            <div className='center-header-type'>
                <img className='imagenlateral1' src={Lateral1} alt="Lateral" />
                <div className="Presentation">
                    <video className='video-background-type' src={videoFondo} autoPlay muted loop></video>
                    <div className="form-container-type">
                        <h2>Registrar Usuario</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-row-users">
                                {/* Campos del formulario */}
                                <div className="form-column">
                                    <p>Nombres</p>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-column">
                                    <p>Apellidos</p>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-column">
                                    <p>Correo</p>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-column">
                                    <p>Cédula</p>
                                    <input
                                        type="text"
                                        name="cedula"
                                        value={formData.cedula}
                                        onChange={handleCedulaChange}
                                        maxLength={10} // Limitar a 10 caracteres
                                    />
                                    {/* Mensaje de error en rojo si la cédula es inválida */}
                                    {cedulaError && <p style={{ color: "red" }}>{cedulaError}</p>}

                                    {/* Mensaje de éxito en verde si la cédula es válida */}
                                    {!cedulaError && formData.cedula.length === 10 && (
                                        <p style={{ color: "green" }}>Cédula verificada</p>
                                    )}
                                </div>
                                <div className="form-column">
                                    <p>Contraseña</p>
                                    <input
                                        type="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="form-column">
                                    <p>Confirmar Contraseña</p>
                                    <input
                                        type="password"
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-column">
                                    <p>Teléfono</p>
                                    <input
                                        type="text"
                                        name="telefono"
                                        value={formData.telefono}
                                        onChange={handleInputChange}
                                        minLength={10}
                                        maxLength={10}
                                        pattern="^[0-9]+$"
                                    />
                                    {formData.telefono.length < 10 && formData.telefono !== "" && (
                                        <p style={{ color: "red" }}>El telefono debe tener al menos 10 dígitos.</p>
                                    )}
                                </div>

                                {/* Selector de Rol */}
                                {isAdmin && (
                                    <div className="form-column">
                                        <p>Rol</p>
                                        <select
                                            name="role"
                                            value={formData.role || "user"} // Predeterminado a "user" si no hay valor
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="user">Cliente</option>
                                            <option value="prov">Proveedor</option>
                                            <option value="admin">Administrador</option>
                                        </select>
                                    </div>
                                )}


                                <div className="form-column">
                                    <p>RUC</p>
                                    <input
                                        type="text"
                                        name="ruc"
                                        value={formData.ruc}
                                        onChange={handleRucChange}
                                        maxLength={13} // Limitar a 10 caracteres
                                    />
                                    {/* Mensaje de error en rojo si el RUC es inválido */}
                                    {rucError && <p style={{ color: "red" }}>{rucError}</p>}

                                    {/* Mensaje de éxito en verde si el RUC es válido */}
                                    {!rucError && formData.ruc.length === 13 && (
                                        <p style={{ color: "green" }}>RUC verificado</p>

                                    )}
                                </div>

                            </div>

                            <button className="btn-space-details" type="submit">
                                Registrar Usuario
                            </button>
                        </form>

                    </div>
                </div>
                <img className='imagenlateral2' src={Lateral2} alt="Lateral" />
            </div>

            <div className="table-container-type">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th className="table-header">Correo</th>
                            <th className="table-header">Nombres</th>
                            <th className="table-header">Apellidos</th>
                            <th className="table-header">Cedula</th>
                            <th className="table-header">Coins</th>
                            <th className="table-header">Coins Comprados</th>
                            <th className="table-header">Ruc</th>
                            <th className="table-header">Telefono</th>
                            <th className="table-header">Role</th>
                            <th className="table-header">Estado</th>
                            <th className="table-header">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuarios.length > 0 ? (
                            usuarios.map((usuario) => (
                                <tr key={usuario.userId} className="table-row">
                                    <td className="table-cell">{usuario.email}</td>
                                    <td className="table-cell">{usuario.name}</td>
                                    <td className="table-cell">{usuario.lastName}</td>
                                    <td className="table-cell">{usuario.cedula}</td>
                                    <td className="table-cell">{usuario.coins}</td>
                                    <td className="table-cell">{usuario.coinsComprados}</td>
                                    <td className="table-cell">{usuario.ruc}</td>
                                    <td className="table-cell">{usuario.telefono}</td>
                                    <td className="table-cell">{usuario.role}</td>
                                    <td className="table-cell">
                                        {usuario.nuevo ? 'Nuevo' : 'Antiguo'}
                                    </td>
                                    <td className="table-cell">
                                        <button onClick={() => openModalUpdate(usuario)}>Editar</button>
                                        <button onClick={() => openDeleteModal(usuario)}>Eliminar</button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ textAlign: 'center', padding: '20px' }}>
                                    No se encontraron usuarios.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Modal
                isOpen={modalIsOpenUpdate}
                onRequestClose={closeModalUpdate}
                contentLabel="Editar Usuario"
            >
                <h2>Editar Usuario</h2>
                <form onSubmit={handleEditSubmit}>
                    <div>
                        <p>Nombres:</p>
                        <input
                            type="text"
                            name="name"
                            value={editedUsuario.name || ""}
                            onChange={handleEditChange}

                        />
                    </div>
                    <div>
                        <p>Apellidos:</p>
                        <input
                            type="text"
                            name="lastName"
                            value={editedUsuario.lastName || ""}
                            onChange={handleEditChange}

                        />
                    </div>
                    <div>
                        <p>Cédula:</p>
                        <input
                            type="text"
                            name="cedula"
                            value={editedUsuario.cedula || ""}
                            onChange={handleEditChange}
                            maxLength={10} // Limitar a 10 caracteres
                        />
                        {/* Mensaje de error en rojo si la cédula es inválida */}
                        {cedulaErrorEdit && <p style={{ color: "red" }}>{cedulaErrorEdit}</p>}

                        {/* Mensaje de éxito en verde si la cédula es válida */}
                        {!cedulaErrorEdit && editedUsuario.cedula?.length === 10 && (
                            <p style={{ color: "green" }}>Cédula verificada</p>
                        )}
                    </div>

                    <div>
                        <p>Telefono:</p>
                        <input
                            type="text"
                            name="telefono" // Asegúrate de que el nombre coincida con el del estado
                            value={editedUsuario.telefono || ""}
                            onChange={handleEditChange}

                        />
                    </div>
                    <div>
                        <p>Coins:</p>
                        <input
                            type="number"
                            name="coins"
                            value={editedUsuario.coins || ""}
                            onChange={handleEditChange}
                        />
                    </div>
                    <div>
                        <p>Coins Comprados:</p>
                        <input
                            type="number"
                            name="coinsComprados"
                            value={editedUsuario.coinsComprados || ""}
                            onChange={handleEditChange}
                        />
                    </div>
                    <div>
                        <p>Estado:</p>
                        <select
                            name="nuevo"  // Asegúrate de que el atributo 'name' esté correctamente definido
                            value={editedUsuario.nuevo ? "Nuevo" : "Antiguo"}  // Mapea a "Nuevo" o "Antiguo" según el valor booleano
                            onChange={(e) =>
                                handleEditChange({
                                    target: {
                                        name: "nuevo",
                                        value: e.target.value === "Nuevo", // Actualiza como booleano
                                    },
                                })
                            }
                        >
                            <option value="Nuevo">Nuevo</option>
                            <option value="Antiguo">Antiguo</option>
                        </select>
                    </div>


                    {userRole === "admin" && (
                        <div>
                            <p>Role:</p>
                            <select
                                name="role"
                                value={editedUsuario.role || ""}
                                onChange={handleEditChange}
                                disabled={userRole !== "admin"} // Solo habilitar si el rol es "admin"
                            >
                                <option value="" disabled>
                                    Seleccione un rol
                                </option>
                                <option value="admin">Administrador</option>
                                <option value="prov">Proveedor</option>
                                <option value="user">Cliente</option>
                            </select>
                        </div>
                    )}

                    <div>
                        <p>RUC:</p>
                        <input
                            type="text"
                            name="ruc"
                            value={editedUsuario.ruc || ""}
                            onChange={handleEditChange}

                        />
                    </div>

                    <button className="modal-button" type="submit">
                        Actualizar
                    </button>
                </form>
                <button
                    className="modal-button"
                    onClick={closeModalUpdate}
                    style={{ marginTop: "10px" }}
                >
                    Cancelar
                </button>
            </Modal>


            <Modal
                isOpen={modalIsOpenDelete}
                onRequestClose={closeModalDelete}
                contentLabel="Confirmar Eliminación"
            >
                <h2>¿Estás seguro que deseas eliminar este usuario?</h2>

                {/* Mostrar los detalles del usuario seleccionado */}
                {selectedUsuario && (
                    <div>
                        <p><strong>Nombre:</strong> {selectedUsuario.name} {selectedUsuario.lastName}</p>
                        <p><strong>Correo Electrónico:</strong> {selectedUsuario.email}</p>
                        {/* Otros campos del usuario */}
                    </div>
                )}

                <p>Esta acción no se puede deshacer.</p>

                <button
                    style={{
                        backgroundColor: 'red',
                        color: 'white',
                        marginRight: '10px',
                        padding: '10px 15px',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                    onClick={handleDelete}
                    className="modal-button"
                >
                    Confirmar Eliminación
                </button>
                <button
                    onClick={closeModalDelete}
                    className="modal-button"
                >
                    Cancelar
                </button>
            </Modal>

        </div>

    );
};

export default Users;
